import React from 'react';
import { Form, Input, Button } from 'antd';
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import useMessage from 'antd/es/message/useMessage';
import { UserService } from '../../../Services/Manage/UserService';

const AddService = ({ initialValues, onSubmit, onCancel }) => {
    const [form] = Form.useForm();
    const [message, messagecontxt] = useMessage();

    const handleFinish = async (values) => {
        try {

            const user = await UserService.getOmeUser();
            const payload = { ...values, added_by: user.uid };

            if (initialValues?.id) {
                console.log(initialValues);

                const req = await ServicetypeService.updateServices(payload, initialValues.id,);
                console.log(req);

                if (req.status) {
                    message.success(req.message)
                    onSubmit(values);
                    form.resetFields();
                } else {
                    message.error(req.message)
                }

            } else {
                const req = await ServicetypeService.createServices(payload);
                console.log(req);
                if (req.status) {
                    message.success(req.message)
                    onSubmit(payload);
                    form.resetFields();
                } else {
                    message.error(req.message)
                }
            }


        } catch (error) {
            console.error("Service operation failed:", error);
        }
    };

    return (
        <>{messagecontxt}
            <Form
                form={form}
                layout="vertical"
                initialValues={initialValues || {}}
                onFinish={handleFinish}
            >
                <Form.Item
                    name="service_name"
                    label="Service Name"
                    rules={[{ required: true, message: 'Please enter service name' }]}
                >
                    <Input size="large" />
                </Form.Item>

                <Form.Item
                    name="service_code"
                    label="Service Code"
                    rules={[{ required: true, message: 'Please enter service code' }]}
                >
                    <Input size="large" />
                </Form.Item>

                <Form.Item name="note" label="Note">
                    <Input.TextArea rows={3} size="large" />
                </Form.Item>

                <div style={{ textAlign: 'right' }}>
                    <Button onClick={onCancel} style={{ marginRight: 8 }} size="large">
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" size="large">
                        {initialValues?.id ? 'Update' : 'Add'}
                    </Button>
                </div>
            </Form>
        </>
    );
};

export default AddService;
